import moment from 'moment';


export const generateFriendlyFilename = (
    url: string,
    userName: string = 'hbscan',
    actionDate?: string,
    index?: number
): string => {
    const cleanUrl = url.split('?')[0];
    const extension = cleanUrl.split('.').pop() || 'file';

    const safeName = userName.replace(/[^a-z0-9]/gi, '_');

    const dateStr = actionDate
        ? moment(actionDate).format('YYYY-MM-DD_HHmm')
        : moment().format('YYYY-MM-DD');

    const suffix = index !== undefined ? `_${index + 1}` : '';

    return `${safeName}_${dateStr}${suffix}.${extension}`;
};